/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getSuggestedFeeds.defs.js'
export { main as default } from './getSuggestedFeeds.defs.js'
